/** `salesorder.statecode`. */
export enum SalesOrderState {
  Active = 0,
  Submitted = 1,
  Canceled = 2,
  Fulfilled = 3,
  Invoiced = 4,
}

/** The `salesorder.statuscode` values the app writes or tests by number. */
export enum SalesOrderStatus {
  Draft = 1,
  Submitted = 268890000,
  /** What the Scrap command sets. */
  Canceled = 548910005,
}
